import { FC, useState } from 'react';
import { ProjectId } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { useProjectDetail } from 'data/projects';
import { useCustomerPreview } from 'hooks/use-customer-preview';
import { PreviewBanner } from './banner';
import { PreviewLoader as Loader } from './loader';
import { disabledStyles as DisabledControls } from './styles';

const Preview: FC<React.PropsWithChildren<{ projectId: ProjectId }>> = ({
  projectId,
}) => {
  const [showLoader, setShowLoader] = useState(true);
  const { data: project } = useProjectDetail(projectId);
  const customerName = project?.customer?.companyName;

  window.setTimeout(() => setShowLoader(false), 3000);

  if (
    window.location?.pathname?.includes?.('live-customer-portal') ||
    window.top !== window
  ) {
    return <></>;
  }

  return (
    <>
      <DisabledControls />
      {showLoader && <Loader />}
      {customerName && <PreviewBanner customerName={customerName} />}
    </>
  );
};

export const PreviewWrapper: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { isPreview, isPending, projectId } = useCustomerPreview();

  return (
    <>
      {isPreview ? (
        projectId != null ? (
          <Preview projectId={ProjectId(projectId)} />
        ) : null
      ) : null}
      {isPending ? <PageLoading size="large" /> : children}
    </>
  );
};
